import { Component, Input, OnInit, inject, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
export class Sale {
  id: number;
  region: string;
  country: string;
  city: string;
  amount: number;
  date: Date;
}

interface StockReport {
  schemeName: string,
  activeOutstanding: number,
  bdOutstanding: number,
  cpOutstanding: number,
  stock: number,
  stockReceived: number
}

@Component({
    selector: 'app-stock-report',
    templateUrl: './stock-report.component.html',
    styleUrls: ['./stock-report.component.scss'],
    standalone: false
})

export class StockReportComponent implements OnInit, OnDestroy {
  private activatedRoute = inject(ActivatedRoute);

  @Input() selectedCompany: number;
  @Input() endDate: Date;
  needStatusOutstanding = true;

  stockList: StockReport[] = [];
  cashBookAmount: number;

  pivotGridDataSource: any;

  routeSubscription: any;
  isCollapsed = false;

  ngOnInit(): void {
    this.routeSubscription = this.activatedRoute.paramMap.subscribe(params => {
      this.selectedCompany = + params.get('companyId');
      this.endDate = (params.get('endDate') == undefined) ? undefined : new Date(params.get('endDate'));

    });

  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
  }
}
